// extracted by mini-css-extract-plugin
export default {"container":"BasicInformation_container__KDLVE","labelTitle":"BasicInformation_labelTitle__8KzJ4","label":"BasicInformation_label__zoCKD","value":"BasicInformation_value__b5vdp"};